module.exports = __webpack_public_path__ + "img/20200606_153324.fa04897f.jpg";